import React, { useState } from 'react';
import './TaskToggle.css';
import NoteOffIcon from '../../../../assets/contacts/notes/note-off.svg';
import NoteHoverIcon from '../../../../assets/contacts/notes/note-hover.svg';
import NoteOnIcon from '../../../../assets/contacts/notes/note-on.svg';

function TaskToggle({ task, isCompleted, onToggle, onNotesClick }) {
  const [isHovered, setIsHovered] = useState(false);

  const handleToggle = () => {
    const newStatus = isCompleted ? 'todo' : 'done';
    onToggle(task.task_type_id, newStatus);
  };

  // Determine which icon to show
  const getNotesIcon = () => {
    if (isHovered) return NoteHoverIcon;  // Always show hover when hovering
    if (task.notes) return NoteOnIcon;  // Has notes (not hovering)
    return NoteOffIcon;  // No notes, not hovering
  };

  return (
    <div className="task-toggle-row">
      <span className="task-name">{task.name}</span>
      <div className="task-actions">
        <img 
          src={getNotesIcon()}
          alt="Notes"
          className="notes-icon"
          onClick={() => onNotesClick(task.task_type_id)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{ width: '55px', height: '17px', cursor: 'pointer' }}
        />
        <label className="ios-toggle">
          <input
            type="checkbox"
            checked={isCompleted}
            onChange={handleToggle}
          />
          <span className="ios-toggle-slider"></span>
        </label>
      </div>
    </div>
  );
}

export default TaskToggle;
